import { useEffect, useState } from "react";
import { Box, Flex, IconButton, Image, Stack } from "@chakra-ui/react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import dashboardIcon from "../../assets/Images/dashboard.svg";
import LeadsIcon from "../../assets/Images/lead-Icon.svg";
import AdminControllIcon from "../../assets/Images/admin-control-icon.svg";
import SupportIcon from "../../assets/Images/support.svg";
import CollapseIcon from "../../assets/Images/CollapseOn.svg";
import Logo from "../../assets/Images/Infusive-Logo.svg";
import CollapseLogo from "../../assets/Images/CollapseLogo.svg";
import * as routesNames from "../../constant/routes";
import MyDiv from "./sidebar.style";
import { useAuth } from "../../hooks/useAuth";
import InfusiveLogo from "../../assets/Images/Infusive-logo (2).svg";
import InfusiveMedia from "../../assets/Images/lead-crm.svg";
import ReportsIcon from "../../assets/Images/Report-Icon.svg";
import DashboardIcon from "../../assets/Images/dashboard-icon.svg";
import CompanyIcon from "../../assets/Images/company-icon.svg";
type SubMenuItem = {
  id: number;
  label: string;
  link: string;
};

type MenuItem = {
  id: number;
  menuName: string;
  menuLogo: string;
  link?: string;
  subMenu?: SubMenuItem[];
};

interface SidebarProps {
  toggleSidebar: boolean;
  handleSidePanel: () => void;
  activePortal: string;
}

const Sidebar = (props: SidebarProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const Menus: MenuItem[] = [];


    Menus.push({ id: 1, menuName: "Dashboard", menuLogo: DashboardIcon, link: routesNames.DASHBOARD });
  
    const subMenu: SubMenuItem[] = [];
   
    subMenu.push({ id: 33, label: "Users", link: routesNames.USERS });
    
    Menus.push({ id: 2, menuName: "Admin Controller", menuLogo: AdminControllIcon, subMenu: subMenu });


    const subMenu1: SubMenuItem[] = [];
   
    subMenu1.push({ id: 34, label: "Central Leads", link: routesNames.LEADPOOL });
    subMenu1.push({ id: 35, label: "Shared Leads", link: routesNames.SHAREDLEAD });

    Menus.push({ id: 3, menuName: "Central Leads", menuLogo: LeadsIcon, subMenu: subMenu1 });
   
  
const subMenu2: SubMenuItem[] = [];
   
    subMenu2.push({ id: 34, label: "CRM Webhook", link: routesNames.CRMWEBHOOK });
    subMenu2.push({ id: 35, label: "Source System", link: routesNames.SOURCESYSTEM });
  

    Menus.push({ id: 4, menuName: "Master", menuLogo: LeadsIcon, subMenu: subMenu2 });



  const [menuId, setMenuId] = useState<number | null>(null);
  const ActiveMenu = Menus;

  useEffect(() => {
    const activeItem = ActiveMenu.find((item) => item.link === location.pathname || item.subMenu?.some((sub) => sub.link === location.pathname));
    if (activeItem) {
      setMenuId(activeItem.id);
    }
  }, [location.pathname]);

  const handleMenu = (itemId: number) => {
    const selectedItem = Menus.find((item) => item.id === itemId);
    if (!selectedItem) return;

    if (selectedItem.link) {
      navigate(selectedItem.link);
      setMenuId(itemId);
      return;
    }

    if (selectedItem.subMenu?.length) {
      setMenuId(itemId);
      const firstSub = selectedItem.subMenu[0];
      if (firstSub) navigate(firstSub.link);
    }
  };

  return (
    <MyDiv>
      <Box className={props.toggleSidebar ? "sidebar_collapse" : "sidebar_wrapper"}>
        {/* COLLAPSE BUTTON */}
        <Box className="collapse-button">
          <IconButton
            className={props.toggleSidebar ? "" : "collpase_icon"}
            onClick={props.handleSidePanel}
            icon={<Image src={CollapseIcon} />}
            aria-label=""
            // bg="#E6EEFA"
            bg="transparent"
          />
        </Box>

        {/* LOGO */}
        <Flex className="logo_wrapper" justifyContent={props.toggleSidebar ? "center" : "flex-start"} ml={3}>
          {/* Always show icon */}
          {/* <Image src={InfusiveMedia} className="logo_icon" boxSize={14} /> */}

          {/* Show text ONLY when expanded */}
          {!props.toggleSidebar && <Image src={InfusiveMedia} className="logo_text" />}
        </Flex>
        <Box className={props.toggleSidebar ? "sidebar_box_toggle" : "sidebar_box"}>
          <Stack spacing="3" className="menu_box">
            {ActiveMenu.map((item) => {
              const isActiveMenu = item.id === menuId;
              const hasSubMenu = item.subMenu?.length;
              const isExpanded = isActiveMenu && hasSubMenu;

              return (
                <Box key={item.id}>
                  <Flex className={isActiveMenu ? "active_menu menu_item" : "menu_item"} onClick={() => handleMenu(item.id)}>
                    <NavLink to={item.link ?? ""} className="font-poppins text_lg font_dark" style={{ justifyContent: props.toggleSidebar ? "center" : "" }}>
                      <Image src={item.menuLogo} className="icon_size" />
                      {!props.toggleSidebar && item.menuName}
                    </NavLink>
                  </Flex>

                  {isExpanded && !props.toggleSidebar && (
                    <Box className="submenu_wrapper">
                      {item.subMenu?.map((subItem) => {
                        const isSubActive = location.pathname === subItem.link;
                        return (
                          <NavLink key={subItem.id} to={subItem.link} className={isSubActive ? "active_submenu submenu_item" : "submenu_item"}>
                            • {subItem.label}
                          </NavLink>
                        );
                      })}
                    </Box>
                  )}
                </Box>
              );
            })}
          </Stack>
        </Box>
      </Box>
    </MyDiv>
  );
};

export default Sidebar;
